// extracted by mini-css-extract-plugin
export default {"preloader":"Preloader_preloader__LVy+h","isFullScreenPreloader":"Preloader_isFullScreenPreloader__GaOVN","image":"Preloader_image__D+Bbf","text":"Preloader_text__geSRO"};